export const _en = {
    // *MSB: non utilisé pour l'instant en cas ou on a besoin plus tard
    materialResourceId:{
        label : "Material Resource"
    },
    cancelDate: {
        label: "Cancel Date"
    },
    cancelReasonId: {
        label: "Reason"
    },
    isReported: {
        label: "Session to report"
    },
    comment: {
        label: "Comment"
    }


};

export const _fr = {
    // *MSB: non utilisé pour l'instant en cas ou on a besoin plus tard
    materialResourceId:{
        label : "Resource material"
    },
    cancelDate: {
        label: "Date d'annulation"
    },
    cancelReasonId: {
        label: "Raison"
    },
    isReported: {
        label: "Séance à reporter"
    },
    comment: {
        label: "Commentaire"
    }

};